import { Component, Input, OnInit } from '@angular/core'
import { SignupService } from 'src/app/services/signup/signup.service'

@Component({
  selector: 'google-login-button',
  templateUrl: './google-login-button.component.html',
  styleUrls: ['./google-login-button.component.scss'],
})
export class GoogleLoginButtonComponent implements OnInit {
  constructor(private signupService: SignupService) {}

  @Input() state: string = location.pathname + location.search

  ngOnInit() {}

  onClick(): void {
    this.signupService.loginWithGoogle(this.state)
  }
}
